"use client";

import { useCanRunPaidActions } from "@/app/(components)/specifics/wrappers/BrandProvider/BrandProvider";
import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import { PageParams } from "@/app/types/common/DefaultProps";
import { DashboardTask } from "@/app/types/dashboard/DashboardTask";
import { ProjectOverviewStats } from "@/app/types/project/ProjectOverview";
import {
  ACTIVATION_STAGES,
  ACTIVATION_START_CONFIG,
  DASHBOARD_TASK_CONFIG,
  pendingStages,
} from "./Dashboard.logic";
import styles from "./Dashboard.module.css";
import DashboardTaskCard from "./DashboardTaskCard";

type Props = {
  params: PageParams;
  tasks: DashboardTask[];
  stats: ProjectOverviewStats;
};

export default function DashboardTasks(props: Props) {
  const T = useT();
  const { params, tasks, stats } = props;

  const canRunPaidActions = useCanRunPaidActions();
  const pending = pendingStages(stats);

  const visible = tasks.filter((task) => {
    const config = DASHBOARD_TASK_CONFIG[task.key];
    return (canRunPaidActions || !config.paid) && !pending.has(config.stage);
  });

  const starters = ACTIVATION_STAGES.filter(
    (stage) => pending.has(stage) && ACTIVATION_START_CONFIG[stage] !== undefined,
  );

  if (starters.length === 0 && visible.length === 0 && tasks.length > 0) {
    return null;
  }

  return (
    <section className={styles.section}>
      <div className={styles.sectionHeader}>
        <h2 className={styles.sectionTitle}>{T(TKey.DASHBOARD_TASKS_TITLE)}</h2>
      </div>

      {starters.length > 0 || visible.length > 0 ? (
        <div className={styles.taskList}>
          {starters.map((stage) => {
            const config = ACTIVATION_START_CONFIG[stage];

            return config ? (
              <DashboardTaskCard
                key={stage}
                params={params}
                stage={stage}
                titleKey={config.titleKey}
                ctaKey={config.ctaKey}
                path={config.path}
              />
            ) : null;
          })}

          {visible.map((task) => (
            <DashboardTaskCard
              key={task.key}
              params={params}
              stage={DASHBOARD_TASK_CONFIG[task.key].stage}
              titleKey={DASHBOARD_TASK_CONFIG[task.key].titleKey}
              ctaKey={DASHBOARD_TASK_CONFIG[task.key].ctaKey}
              path={DASHBOARD_TASK_CONFIG[task.key].path}
              count={task.count}
            />
          ))}
        </div>
      ) : (
        <p className={styles.empty}>{T(TKey.DASHBOARD_TASKS_EMPTY)}</p>
      )}
    </section>
  );
}
